import { useMemo } from "react";
import type { StripeAddressElementOptions } from "@stripe/stripe-js";

export const useAddressElementDisplay = () =>
  useMemo<StripeAddressElementOptions["display"]>(
    () => ({
      // We always display the full name. No support for organizations yet.
      name: "full",
    }),
    [],
  );
